export interface PageMetaTags {
  title: string;
  description: string;
  url?: string;
  image?: string;
  type?: "website" | "article";
}

const SITE_NAME = "Centre for Human Sciences";

function upsertMetaTag(
  attribute: "name" | "property",
  key: string,
  content: string,
) {
  let element = document.querySelector(
    `meta[${attribute}="${key}"]`,
  ) as HTMLMetaElement | null;

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }

  element.content = content;
}

function upsertLinkTag(rel: string, href: string) {
  let element = document.querySelector(
    `link[rel="${rel}"]`,
  ) as HTMLLinkElement | null;

  if (!element) {
    element = document.createElement("link");
    element.rel = rel;
    document.head.appendChild(element);
  }

  element.href = href;
}

export function applyPageMeta(meta: PageMetaTags, path: string) {
  const documentTitle =
    path === "/"
      ? "Centre for Human Sciences | Rishihood University"
      : `${meta.title} | ${SITE_NAME}`;

  document.title = documentTitle;
  upsertMetaTag("name", "description", meta.description);

  const url = meta.url || `${window.location.origin}${path === "/" ? "" : path}`;
  const image = meta.image || `${window.location.origin}/favicon.svg`;
  const type = meta.type || "website";

  upsertLinkTag("canonical", url);
  upsertMetaTag("property", "og:title", meta.title);
  upsertMetaTag("property", "og:description", meta.description);
  upsertMetaTag("property", "og:type", type);
  upsertMetaTag("property", "og:url", url);
  upsertMetaTag("property", "og:site_name", SITE_NAME);
  upsertMetaTag("property", "og:image", image);
  upsertMetaTag("name", "twitter:card", "summary_large_image");
  upsertMetaTag("name", "twitter:title", meta.title);
  upsertMetaTag("name", "twitter:description", meta.description);
  upsertMetaTag("name", "twitter:image", image);
}

export function isBlogDetailPath(path: string): boolean {
  return /^\/blogs\/\d+(?:\/[^/]+)?\/?$/.test(path);
}

export function isAuthorPath(path: string): boolean {
  return /^\/authors\/\d+(?:\/[^/]+)?\/?$/.test(path);
}
